module.exports = __WEBPACK_EXTERNAL_MODULE_20__;


/*****************
 ** WEBPACK FOOTER
 ** external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}
 ** module id = 20
 ** module chunks = 0
 **/